import { render } from "./index.vue?vue&type=template&id=ed77505c&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./style.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__